export const tableColumnsSize = {
  startDate: 150,
  status: 170,
  dueDate: 100,
  uploadButton: 110,
  actions: 40
}

export const uploadRemoveStyle = {
  maxWidth: tableColumnsSize.uploadButton,
  padding: '0 8px',
  // align the Upload and Remove texts
  display: 'flex',
  justifyContent: 'center'
}

export const requestedFilesColumnsSchema = [
  {
    header: 'Requested file'
  },
  {
    header: 'Start Date',
    style: { maxWidth: tableColumnsSize.startDate }
  },
  {
    header: 'Status',
    style: { maxWidth: tableColumnsSize.status }
  },
  {
    header: 'Due date',
    style: { maxWidth: tableColumnsSize.dueDate }
  },
  {
    style: uploadRemoveStyle
  },
  {
    style: { maxWidth: tableColumnsSize.actions }
  }
]
